import { actionTypes } from 'app/types/action_types';

const initialState = {};

const mapPayload = (payload) => {
  if (Object.keys(payload).length === 0) return initialState;
  return {
    assetType: payload.assetType,
    family: payload.family,
    heroColor: payload.heroColor,
    headerTitle: payload.headerTitle,
    rememberLastSearchScope: payload.rememberLastSearchScope,
  };
};

// eslint-disable-next-line default-param-last
const homeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE:
      return mapPayload(action.payload);
    default:
      return state;
  }
};

export default homeReducer;
